import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Facebook = forwardRef<SVGSVGElement, IconProps>(({ color, size = 20 }, forwardedRef) => {
  if (color) {
    return (
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1824 5.50634C18.0411 6.84752 18.4977 8.40671 18.4979 9.99932C18.4978 11.984 17.7896 13.9036 16.5007 15.4128C15.2118 16.922 13.4268 17.9217 11.4667 18.2322V12.4091H13.4083L13.4083 12.4089H13.4084L13.7781 9.99932H11.4667V8.4367C11.4667 8.24093 11.4951 8.04663 11.5623 7.87019C11.5684 7.85412 11.5748 7.83819 11.5816 7.82243C11.7507 7.42844 12.125 7.13476 12.8249 7.13476H13.8749V7.13452H13.875V5.08332C13.875 5.08332 12.9219 4.92081 12.0104 4.92081C10.3609 4.92081 9.207 5.78619 8.92786 7.3761C8.8847 7.62164 8.86242 7.88446 8.86242 8.16401V9.99932H6.74689V9.99956H6.7468V12.4091H8.86242V18.2322C7.28953 17.9834 5.82087 17.289 4.63031 16.2314C3.43971 15.1737 2.57709 13.797 2.14455 12.2642C1.71201 10.7315 1.72767 9.10692 2.18967 7.58281C2.65168 6.0587 3.54069 4.69889 4.75144 3.66436C5.9622 2.62984 7.44401 1.96392 9.02144 1.74545C10.5989 1.52698 12.2059 1.7651 13.6522 2.43162C15.0985 3.09814 16.3236 4.16515 17.1824 5.50634Z"
          fill={color}
        />
      </svg>
    )
  }

  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M18.4979 9.99933C18.4977 8.40672 18.0411 6.84753 17.1823 5.50635C16.3236 4.16516 15.0985 3.09815 13.6522 2.43163C12.2059 1.76511 10.5989 1.52699 9.02143 1.74546C7.444 1.96393 5.96219 2.62985 4.75143 3.66437C3.54068 4.6989 2.65167 6.05871 2.18966 7.58282C1.72766 9.10693 1.712 10.7315 2.14454 12.2643C2.57708 13.797 3.4397 15.1737 4.6303 16.2314C5.82089 17.289 7.28958 17.9834 8.86251 18.2322V12.4089H6.74688V9.99933H8.86251V8.16377C8.86251 6.07403 10.1063 4.92082 12.0104 4.92082C12.9219 4.92082 13.875 5.08333 13.875 5.08333V7.13453H12.825C11.7896 7.13453 11.4667 7.77728 11.4667 8.43671V9.99933H13.7781L13.4083 12.4089H11.4667V18.2322C13.4268 17.9217 15.2118 16.922 16.5007 15.4128C17.7896 13.9036 18.4978 11.984 18.4979 9.99933Z"
        fill="#1877F2"
      />
      <path
        d="M13.7781 9.99937H11.4666V8.43675C11.4666 7.77733 11.7896 7.13457 12.825 7.13457H13.875V5.08337C13.875 5.08337 12.9218 4.92086 12.0104 4.92086C10.1062 4.92086 8.86247 6.07511 8.86247 8.16381V9.99937H6.74685V12.4089H8.86247V18.2323C9.29322 18.2997 9.72856 18.3335 10.1646 18.3333C10.6006 18.3335 11.0359 18.2997 11.4666 18.2323V12.4089H13.4083"
        fill="white"
      />
    </svg>
  )
})

export default Facebook
